import {
  CULTURAL_CREATE_SUB_CATEGORY_SUCCESS,
  CULTURAL_CREATE_SUB_CATEGORY_FAIL,
} from "../actionTypes";

const initialState = {
  subCategory: null,
  loading: false,
  error: null,
};

const cultureSubCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case CULTURAL_CREATE_SUB_CATEGORY_SUCCESS:
      return {
        ...state,
        subCategory: action.payload,
        loading: false,
        error: null,
      };

    case CULTURAL_CREATE_SUB_CATEGORY_FAIL:
      return {
        ...state,
        loading: false,
        error: "Failed to create subcategory",
      };

    default:
      return state;
  }
};

export default cultureSubCategoryReducer;
